(function() {
  'use strict';

  // --- CSS ---
  var style = document.createElement('style');
  style.id = 'koivos-drawer-styles';
  style.textContent = [
    '#koivos-hamburger{display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;padding:8px;color:inherit;z-index:200;flex-shrink:0;}',
    '#koivos-hamburger:hover{opacity:0.7;}',
    '#koivos-hamburger svg{width:22px;height:22px;}',
    '#kv-wishlist-btn{display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;padding:8px;color:inherit;flex-shrink:0;text-decoration:none;}',
    '#kv-wishlist-btn:hover{opacity:0.7;}',
    '#kv-wishlist-btn svg{width:20px;height:20px;}',
    '#koivos-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:9998;opacity:0;visibility:hidden;transition:opacity 0.3s,visibility 0.3s;}',
    '#koivos-overlay.kv-open{opacity:1;visibility:visible;}',
    '#koivos-drawer{position:fixed;top:0;left:0;width:320px;max-width:88vw;height:100vh;background:#0f172a;color:#f8fafc;z-index:9999;transform:translateX(-100%);transition:transform 0.35s cubic-bezier(0.4,0,0.2,1);display:flex;flex-direction:column;overflow:hidden;}',
    '#koivos-drawer.kv-open{transform:translateX(0);}',
    '.kv-dh{display:flex;align-items:center;justify-content:space-between;padding:20px 24px;border-bottom:1px solid rgba(255,255,255,0.1);}',
    '.kv-dh-logo{display:flex;align-items:center;height:36px;}',
    '.kv-dh-logo svg{height:36px;width:auto;}',
    '.kv-dh-close{background:none;border:none;color:#94a3b8;cursor:pointer;padding:4px;display:flex;line-height:1;}',
    '.kv-dh-close:hover{color:#f8fafc;}',
    '.kv-db{flex:1;overflow-y:auto;padding:8px 0;}',
    '.kv-db::-webkit-scrollbar{width:3px;}',
    '.kv-db::-webkit-scrollbar-thumb{background:#334155;border-radius:2px;}',
    '.kv-lbl{font-size:0.59rem;font-weight:700;letter-spacing:0.16em;color:#C9A95A;padding:16px 24px 5px;text-transform:uppercase;display:flex;align-items:center;gap:10px;}',
    '.kv-lbl::after{content:"";flex:1;height:1px;background:rgba(201,169,90,0.2);}',
    '.kv-link{display:flex;align-items:flex-start;gap:13px;padding:9px 24px;color:#cbd5e1;text-decoration:none;border-left:2px solid transparent;transition:background 0.18s,border-color 0.18s;}',
    '.kv-link:hover{background:rgba(201,169,90,0.07);border-left-color:#C9A95A;}',
    '.kv-link svg{width:17px;height:17px;flex-shrink:0;opacity:0.45;margin-top:3px;transition:opacity 0.18s;}',
    '.kv-link:hover svg{opacity:0.85;}',
    '.kv-link-body{display:flex;flex-direction:column;gap:2px;min-width:0;}',
    '.kv-link-title{font-size:0.865rem;font-weight:500;color:#e2e8f0;transition:color 0.18s;display:flex;align-items:center;gap:0;}',
    '.kv-link:hover .kv-link-title{color:#fff;}',
    '.kv-link-sub{font-size:0.67rem;color:#3d4f68;letter-spacing:0.01em;line-height:1.3;transition:color 0.18s;}',
    '.kv-link:hover .kv-link-sub{color:#64748b;}',
    '#koivos-drawer a[href="/collections/novedades"].kv-link::after{background:#C9A95A!important;color:#0f172a!important;font-size:0.52rem!important;font-weight:800!important;letter-spacing:0.09em!important;padding:2px 5px!important;border-radius:2px!important;align-self:flex-start!important;margin-top:3px!important;flex-shrink:0!important;line-height:1.4!important;}',
    '#koivos-drawer .badge,#koivos-drawer .nav-badge,#koivos-drawer [class*="badge"]:not(.kv-tgl-btn):not([class*="kvo-"]){background:#C9A95A!important;color:#0f172a!important;border:none!important;font-size:0.52rem!important;font-weight:800!important;padding:2px 5px!important;border-radius:2px!important;margin-left:6px!important;}',
    '.kv-div{height:1px;background:rgba(255,255,255,0.06);margin:4px 0;}',
    '.kv-df{border-top:1px solid rgba(255,255,255,0.1);padding:14px 24px;display:flex;flex-direction:column;gap:13px;}',
    '.kv-fl{display:flex;align-items:center;gap:10px;color:#94a3b8;text-decoration:none;font-size:0.83rem;transition:color 0.15s;}',
    '.kv-fl:hover{color:#f8fafc;}',
    '.kv-fl svg{width:15px;height:15px;opacity:0.7;}',
    '.kv-tgl-row{display:flex;align-items:center;justify-content:space-between;}',
    '.kv-tgl-lbl{display:flex;align-items:center;gap:9px;color:#94a3b8;font-size:0.83rem;}',
    '.kv-tgl-lbl svg{width:15px;height:15px;}',
    '.kv-tgl-btn{width:38px;height:21px;background:#334155;border-radius:11px;border:none;cursor:pointer;position:relative;transition:background 0.2s;flex-shrink:0;}',
    '.kv-tgl-btn::after{content:"";position:absolute;top:3px;left:3px;width:15px;height:15px;background:#fff;border-radius:50%;transition:transform 0.2s;}',
    '.kv-tgl-btn.on{background:#C9A95A;}',
    '.kv-tgl-btn.on::after{transform:translateX(17px);}',
  'html,body,main,.page-wrapper,dialog,cart-drawer,.card,.card-wrapper,header,.header,footer,.footer{transition:background-color .3s ease,color .3s ease,border-color .3s ease;}',
  'html.kv-dark .section-background{transition:none!important;}',

  'html.kv-dark{--color-background:#1a1a1a;--color-background-rgb:26 26 26;--color-foreground:#f0f0f0;--color-foreground-rgb:240 240 240;--color:#f0f0f0;--color-rgb:240 240 240;--color-border:#333;--color-border-rgb:51 51 51;--palette-lightest:#252525;--palette-lightest-rgb:37 37 37;--palette-darkest:#f0f0f0;--palette-darkest-rgb:240 240 240;--color-input-background:#2a2a2a;--color-input-text:#f0f0f0;--color-input-text-rgb:240 240 240;--color-input-border:#444;--color-shadow-rgb:0 0 0;--color-drawer-shadow-rgb:0 0 0;--color-popover-shadow-rgb:0 0 0;--color-drawer-background:#252525;--color-drawer-text:#f0f0f0;--color-popover-background:#252525;--color-popover-text:#f0f0f0;background-color:#1a1a1a;color:#f0f0f0;}',

  'html.kv-dark body{background-color:#1a1a1a!important;color:#f0f0f0!important;}',

  'html.kv-dark .shopify-section{--color-background:#1a1a1a!important;--color-background-rgb:26 26 26!important;--color-foreground:#f0f0f0!important;--color-foreground-rgb:240 240 240!important;--color:#f0f0f0!important;--color-rgb:240 240 240!important;--color-border:#333!important;background-color:#1a1a1a!important;color:#f0f0f0!important;}',

  'html.kv-dark [class*="color-custom-"]{--color-background:#1a1a1a!important;--color-background-rgb:26 26 26!important;--color-foreground:#f0f0f0!important;--color-foreground-rgb:240 240 240!important;--color:#f0f0f0!important;--color-rgb:240 240 240!important;--color-border:#333!important;--palette-lightest:#252525!important;--palette-darkest:#f0f0f0!important;background-color:#1a1a1a!important;color:#f0f0f0!important;}',

  'html.kv-dark .section-background,html.kv-dark [class*="color-custom-"].section-background{background-color:#1a1a1a!important;background-image:none!important;}',

  'html.kv-dark #header-group,html.kv-dark sticky-header,html.kv-dark .header{background-color:#111!important;--color-background:#111!important;--color:#f0f0f0!important;border-color:#333!important;}',
  'html.kv-dark .header-announcements__inner{background-color:#0a0a0a!important;}',

  'html.kv-dark footer .shopify-section,html.kv-dark footer,html.kv-dark .footer,[html.kv-dark class*="footer__"]{background-color:#111!important;--color:#aaa!important;color:#aaa!important;border-color:#333!important;}',
  'html.kv-dark footer a,html.kv-dark .footer a{color:#aaa!important;}',

  'html.kv-dark dialog,html.kv-dark cart-drawer,html.kv-dark .drawer{background-color:#252525!important;--color-background:#252525!important;--color:#f0f0f0!important;color:#f0f0f0!important;border-color:#333!important;}',
  'html.kv-dark .predictive-search,html.kv-dark .search-modal,html.kv-dark .search-modal__content{background-color:#252525!important;--color-background:#252525!important;--color:#f0f0f0!important;color:#f0f0f0!important;}',

  'html.kv-dark .card,html.kv-dark .card-wrapper,html.kv-dark .product-card,html.kv-dark .collection-card,html.kv-dark .predictive-search-results__card{background-color:#252525!important;--color-background:#252525!important;--color:#f0f0f0!important;border-color:#333!important;}',

  'html.kv-dark input:not([type=range]):not([type=checkbox]):not([type=radio]),html.kv-dark textarea,html.kv-dark select{background-color:#2a2a2a!important;color:#f0f0f0!important;border-color:#444!important;}',
  'html.kv-dark input::placeholder,html.kv-dark textarea::placeholder{color:#888!important;opacity:1!important;}',
  'html.kv-dark input[type=checkbox]{background-color:#2a2a2a!important;border-color:#555!important;}',
  'html.kv-dark input[type=checkbox]:checked{background-color:#f0f0f0!important;border-color:#f0f0f0!important;}',
  'html.kv-dark input[type=radio]{background-color:transparent!important;border-color:#555!important;}',
  'html.kv-dark input[type=radio]:checked{border-color:#f0f0f0!important;}',
  'html.kv-dark input[type=radio]:checked:after{background:#f0f0f0!important;}',

  'html.kv-dark .button-secondary{--button-color:#f0f0f0!important;--button-border-color:#555!important;}',
  'html.kv-dark hr{border-color:#333!important;}',
  'html.kv-dark a:not(.button):not(.button-secondary):not([class*="btn"]):not(.kv-nav-link){color:#93c5fd;}',
  'html.kv-dark ::-webkit-scrollbar-thumb{background-color:rgba(255,255,255,.2)!important;}',
  'html.kv-dark img,html.kv-dark video,html.kv-dark iframe{filter:none!important;}'

].join('');
  document.head.appendChild(style);

  // --- HTML ---
  var html = '<div id="koivos-overlay"></div>' +
  '<div id="koivos-drawer" role="dialog" aria-modal="true" aria-label="Menu de navegacion">' +
    '<div class="kv-dh">' +
      '<div class="kv-dh-logo"><svg viewBox="0 0 320 64" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="miter"><line x1="8" y1="10" x2="8" y2="54"/><line x1="8" y1="32" x2="28" y2="10"/><line x1="8" y1="32" x2="28" y2="54"/><line x1="35" y1="10" x2="50" y2="54"/><line x1="70" y1="10" x2="50" y2="54"/></g><line x1="82" y1="10" x2="82" y2="54" stroke="#C9A95A" stroke-width="1" opacity="0.8"/><text x="96" y="42" font-family="Cormorant Garamond,Georgia,serif" font-size="32" font-weight="300" fill="white" text-anchor="start" letter-spacing="6">KOIVOS</text></svg></div>' +
      '<button class="kv-dh-close" id="kv-close" aria-label="Cerrar menu">' +
        '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"><line x1=\"18\" y1=\"6\" x2=\"6\" y2=\"18\"/><line x1=\"6\" y1=\"6\" x2=\"18\" y2=\"18\"/></svg>' +
      '</button>' +
    '</div>' +
    '<div class="kv-db">' +
    '<div class="kv-db">' +

  // ─── TIENDA ───
  '<div class="kv-lbl">Tienda</div>' +

  '<a href="/collections/descubre-todo" class="kv-link">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>' +
    '<div class="kv-link-body"><span class="kv-link-title">Descubre todo</span><span class="kv-link-sub">Explora nuestra tienda</span></div>' +
  '</a>' +

      // ── COLECCIONES ──
      '<div class="kv-lbl">Colecciones</div>' +

      '<a href="/collections/belleza-skincare-1" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Ritual de Piel</span><span class="kv-link-sub">Rituales · Hidratación · Luminosidad</span></div>' +
      '</a>' +

      '<a href="/collections/sueno-descanso" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Sue&#241;o &amp; Descanso</span><span class="kv-link-sub">Terapia · Recuperación · Confort</span></div>' +
      '</a>' +

      '<a href="/collections/masaje-relajacion" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"/><path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"/><path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Masaje &amp; Relajaci&#243;n</span><span class="kv-link-sub">Percusión · Calor · Alivio muscular</span></div>' +
      '</a>' +

      '<a href="/collections/fitness-recuperacion" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Cuerpo &amp; Movimiento</span><span class="kv-link-sub">Electroterapia · Compresión · Rendimiento</span></div>' +
      '</a>' +

      '<a href="/collections/aromaterapia" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Aromaterapia</span><span class="kv-link-sub">Difusores · Aceites esenciales · Ambientes</span></div>' +
      '</a>' +

      '<a href="/collections/terapia-con-luz" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Luz &amp; Bienestar</span><span class="kv-link-sub">LED · Fototerapia · Rejuvenecimiento</span></div>' +
      '</a>' +

      '<a href="/collections/salud-bienestar" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Salud &amp; Bienestar</span><span class="kv-link-sub">Visión · Protección · Salud digital</span></div>' +
      '</a>' +

      // ── DESCUBRE ──
      '<div class="kv-lbl">Descubre</div>' +

      '<a href="/collections/novedades" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Novedades</span><span class="kv-link-sub">Los &#250;ltimos lanzamientos</span></div>' +
      '</a>' +

      '<a href="/wishlist" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Favoritos</span><span class="kv-link-sub">Tu lista de deseos</span></div>' +
      '</a>' +

      // ── NOSOTROS ──
      '<div class="kv-lbl">Nosotros</div>' +

      '<a href="/pages/contacto" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Contacto &amp; Soporte</span><span class="kv-link-sub">Estamos aqu&#237; para ayudarte</span></div>' +
      '</a>' +

      '<a href="/pages/politica-de-envios" class="kv-link">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
        '<div class="kv-link-body"><span class="kv-link-title">Env&#237;os &amp; Seguimiento</span><span class="kv-link-sub">Plazos · Tracking · Devoluciones</span></div>' +
      '</a>' +

    '</div>' +
    '<div class="kv-df">' +
      '<a href="/account" class="kv-fl"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\"><path d=\"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2\"/><circle cx=\"12\" cy=\"7\" r=\"4\"/></svg>Configuraci&#243;n de cuenta</a>' +
      '<div class="kv-tgl-row">' +
        '<span class="kv-tgl-lbl"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\"><circle cx=\"12\" cy=\"12\" r=\"5\"/><line x1=\"12\" y1=\"1\" x2=\"12\" y2=\"3\"/><line x1=\"12\" y1=\"21\" x2=\"12\" y2=\"23\"/></svg>Modo oscuro</span>' +
        '<button class="kv-tgl-btn" id="kv-dark-tgl" aria-label="Toggle modo oscuro"></button>' +
      '</div>' +
    '</div>' +
  '</div>';

  document.body.insertAdjacentHTML('beforeend', html);

  // --- Refs ---
  var overlay = document.getElementById('koivos-overlay');
  var drawer  = document.getElementById('koivos-drawer');
  var closeBtn = document.getElementById('kv-close');
  var darkTgl  = document.getElementById('kv-dark-tgl');

  function open()  { drawer.classList.add('kv-open'); overlay.classList.add('kv-open'); document.body.style.overflow='hidden'; }
  function close() { drawer.classList.remove('kv-open'); overlay.classList.remove('kv-open'); document.body.style.overflow=''; }

  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });


  // Dark mode persistence
  /* Dark mode persistence disabled — always starts in light mode */
  darkTgl.addEventListener('click', function(){
    var on = darkTgl.classList.toggle('on');
    document.body.classList.toggle('kv-dark', on); document.documentElement.classList.toggle('kv-dark', on);
    /* localStorage persistence removed */
  });

  // Inject hamburger button
  function injectHamburger() {
    if(document.getElementById('koivos-hamburger')) return;

    var btn = document.createElement('button');
    btn.id = 'koivos-hamburger';
    btn.setAttribute('aria-label','Abrir menu de navegacion');
    btn.setAttribute('type','button');
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
    btn.addEventListener('click', open);

    // 1. Intentar insertar como PRIMER hijo de la columna izquierda del header
    //    → garantiza que quede a la izquierda del todo, antes del drawer nativo
    var leftCol = document.querySelector('.header__column--left, .header__column--start');
    if (leftCol) {
      leftCol.insertBefore(btn, leftCol.firstChild);
      return;
    }

    // 2. Fallback: insertar antes del drawer nativo si existe
    var drawerWrapper = document.querySelector('.header__drawer');
    if (drawerWrapper && drawerWrapper.parentNode) {
      drawerWrapper.parentNode.insertBefore(btn, drawerWrapper);
      return;
    }

    // 3. Fallback final: antes del logo
    var sels = ['.header__logo','.header-logo','[class*="header__logo"]','.header__heading'];
    var logoEl = null;
    for(var i=0;i<sels.length;i++){
      logoEl = document.querySelector(sels[i]);
      if(logoEl) break;
    }
    if(logoEl){
      logoEl.parentElement.insertBefore(btn, logoEl);
    } else {
      var hdr = document.querySelector('.header__inner, .site-header__inner, header');
      if(hdr) hdr.insertBefore(btn, hdr.firstChild);
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', injectHamburger);
  } else {
    injectHamburger();
  }
  setTimeout(injectHamburger, 600);
  setTimeout(injectHamburger, 2000);

  // ─── FIX #3: Logo KV junto al hamburger (móvil) ─────────────────
  // Horizon aplica position:absolute al logo en móvil con alta
  // especificidad — ni CSS !important ni style inline lo cancelan
  // porque Horizon lo reaplica vía JS en cada render.
  // Solución: clonar el logo, insertarlo después del hamburger con
  // estilos inline forzados, y ocultar el original.
  // ─────────────────────────────────────────────────────────────────
  function fixLogoPosition() {
    if (window.innerWidth > 749) return;
    if (document.getElementById('kv-logo-clone')) return;

    var hamburger = document.getElementById('koivos-hamburger');
    var leftCol   = document.querySelector('.header__column--left, .header__column--start');
    if (!hamburger || !leftCol) return;

    var logo = leftCol.querySelector('a.header-logo, .header-logo');
    if (!logo) return;

    var clone = logo.cloneNode(true);
    clone.id = 'kv-logo-clone';
    // Quitar header-logo para que Horizon no aplique position:absolute al clon
    clone.className = clone.className.replace('header-logo', '').trim();
    clone.style.cssText = 'position:static!important;left:auto!important;top:auto!important;transform:none!important;-webkit-transform:none!important;margin:0!important;flex-shrink:0!important;display:flex!important;align-items:center!important;text-decoration:none!important;';

    leftCol.insertBefore(clone, hamburger.nextSibling);

    // Ocultar el original
    logo.style.setProperty('display', 'none', 'important');
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', fixLogoPosition);
  } else {
    fixLogoPosition();
  }
  setTimeout(fixLogoPosition, 400);
  setTimeout(fixLogoPosition, 1500);

  // ─── FIX #4: Lupa a la derecha en móvil ──────────────────────────
  // Horizon muestra en móvil la lupa de la columna izquierda y oculta
  // la de la derecha. Los class names varían por versión → usamos JS
  // para buscar todos los search-button / .search-action y decidir
  // cuáles mostrar u ocultar según su posición en el DOM.
  // ─────────────────────────────────────────────────────────────────
  // ─── FIX #4: Mover la lupa de Horizon a la derecha ──────────────
  // En vez de clonar o inyectar un nuevo botón, movemos el elemento
  // real de Horizon (.search-action--hidden-on-menu) a header-actions.
  // Al moverlo, desaparece de la izquierda y conserva todos sus
  // listeners y funcionalidad originales.
  // ─────────────────────────────────────────────────────────────────
  function moveSearchBtn() {
    if (window.innerWidth > 749) return;
    if (document.getElementById('kv-search-moved')) return;

    var leftSearch   = document.querySelector('.search-action--hidden-on-menu');
    var headerActions = document.querySelector('header-actions');
    if (!leftSearch || !headerActions) return;

    // Mover el nodo real (preserva listeners y funcionalidad de Horizon)
    headerActions.insertBefore(leftSearch, headerActions.firstChild);

    // Forzar visible — en header-actions ya no aplica la media query de Horizon
    leftSearch.style.setProperty('display', 'flex', 'important');
    leftSearch.style.setProperty('align-items', 'center', 'important');
    leftSearch.style.setProperty('justify-content', 'center', 'important');
    leftSearch.style.setProperty('width', '44px', 'important');
    leftSearch.style.setProperty('height', '44px', 'important');
    leftSearch.style.setProperty('flex-shrink', '0', 'important');

    var done = document.createElement('span');
    done.id = 'kv-search-moved';
    done.style.display = 'none';
    document.head.appendChild(done);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', moveSearchBtn);
  } else {
    moveSearchBtn();
  }
  setTimeout(moveSearchBtn, 400);
  setTimeout(moveSearchBtn, 1500);

  // =====================================================
  // KVO SWATCH → GALLERY IMAGE FIX
  // El kvo-code tiene un bug: al cambiar de color, fuerza
  // la imagen equivocada con ~450ms de delay. Este observer
  // detecta cuándo el swatch activo cambia y fuerza el
  // thumbnail correcto 600ms después (tras el delay del kvo).
  // =====================================================
  function initKvoGalleryFix() {
    var swatchContainer = document.querySelector('.kvo-swatches');
    if (!swatchContainer) return; // Solo aplica en páginas con kvo swatches

    function forceCorrectImage(colorTitle) {
      var product = window.kvo_product;
      if (!product || !product.variants || !product.media) return;
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].option1 === colorTitle) { variant = product.variants[i]; break; }
      }
      if (!variant || !variant.featured_image) return;
      var targetPos = variant.featured_image.position;
      var targetMedia = null;
      for (var j = 0; j < product.media.length; j++) {
        if (product.media[j].position === targetPos) { targetMedia = product.media[j]; break; }
      }
      if (!targetMedia) return;
      var thumbs = document.querySelectorAll('.kvo-gal__thumb');
      var correctThumb = null;
      for (var k = 0; k < thumbs.length; k++) {
        if (thumbs[k].getAttribute('aria-label') === targetMedia.alt) { correctThumb = thumbs[k]; break; }
      }
      if (correctThumb) {
        setTimeout(function() { correctThumb.click(); }, 600);
      }
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          var el = m.target;
          if (el.classList.contains('kvo-swatch') && el.classList.contains('active')) {
            forceCorrectImage(el.title);
          }
        }
      });
    });

    var swatches = swatchContainer.querySelectorAll('.kvo-swatch');
    swatches.forEach(function(s) {
      observer.observe(s, { attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKvoGalleryFix);
  } else {
    initKvoGalleryFix();
  }
  // Retry por si los swatches cargan tarde
  setTimeout(initKvoGalleryFix, 1500);

})();

// =====================================================
// KVO PACK CARDS IN QUICK-ADD MODAL v2.0
// Transforma los botones de Pack en el carrito rápido
// en tarjetas con precio, ahorro y badges, igual que
// en la página de producto.
// v2.0: MutationObserver detecta re-renders de Shopify
// (ej. al cambiar color) y re-aplica las cards automáticamente.
// =====================================================
(function () {
  'use strict';

  var PACK_CFG = {
    '1 unidad':   { units: 1, badge: '' },
    '2 unidades': { units: 2, badge: 'hot' },
    '3 unidades': { units: 3, badge: 'rec' }
  };

  function fmt(n) {
    return parseFloat(n).toFixed(2).replace('.', ',') + '€';
  }

  function buildCard(packValue, price, basePrice) {
    var cfg   = PACK_CFG[packValue] || { units: 1, badge: '' };
    var total = parseFloat(price);
    var base  = parseFloat(basePrice);
    var orig  = base * cfg.units;
    var save  = cfg.units > 1 ? (orig - total) : 0;
    var perU  = total / cfg.units;

    var badge = '';
    if (cfg.badge === 'hot') {
      badge = '<div class="kvo-pm-badge-row"><span class="kvo-pm-badge kvo-pm-badge--hot">🏆 MÁS VENDIDO</span></div>';
    } else if (cfg.badge === 'rec') {
      badge = '<div class="kvo-pm-badge-row"><span class="kvo-pm-badge kvo-pm-badge--rec">⭐ RECOMENDADO</span></div>';
    }

    var prices = '<div class="kvo-pm-prices">' +
      '<span class="kvo-pm-price">' + fmt(total) + '</span>' +
      (save > 0 ? '<span class="kvo-pm-original">' + fmt(orig) + '</span>' : '') +
      '</div>';

    var info = save > 0
      ? '<div class="kvo-pm-info">' +
          '<span class="kvo-pm-savings">Ahorras ' + fmt(save) + '</span>' +
          '<span class="kvo-pm-unit">' + fmt(perU) + ' / unidad</span>' +
        '</div>'
      : '';

    return '<div class="kvo-pm-card">' + badge +
      '<div class="kvo-pm-name">' + packValue + '</div>' +
      prices + info + '</div>';
  }

  function renderCards(dialog, packFieldset, variants) {
    var colorInput = dialog.querySelector('.variant-option--swatches input:checked');
    var selColor   = colorInput ? colorInput.value : null;

    var baseVariant = variants.find(function (v) {
      if (selColor) {
        return (v.option1 === selColor && v.option2 === '1 unidad') ||
               (v.option2 === selColor && v.option1 === '1 unidad');
      }
      return v.option2 === '1 unidad' || v.option1 === '1 unidad';
    }) || variants[0];
    var basePrice = baseVariant ? baseVariant.price : '0';

    packFieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var packValue = input.value;
      var label = input.closest ? input.closest('label') : null;
      if (!label) return;

      label.classList.add('kvo-pm-label');

      var variant = null;
      if (selColor) {
        variant = variants.find(function (v) {
          return (v.option1 === selColor && v.option2 === packValue) ||
                 (v.option2 === selColor && v.option1 === packValue);
        });
      }
      if (!variant) {
        variant = variants.find(function (v) {
          return v.option2 === packValue || v.option1 === packValue;
        });
      }
      if (!variant) return;

      var textSpan = label.querySelector('.variant-option__button-label__text');
      if (textSpan) {
        textSpan.innerHTML = buildCard(packValue, variant.price, basePrice);
      }
    });
  }

  function enhanceDialog(dialog, variants) {
    var fieldsets = dialog.querySelectorAll('fieldset.variant-option');
    var packFieldset = null;

    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && legend.textContent.trim() === 'Pack') {
        packFieldset = fieldsets[i];
        break;
      }
    }
    if (!packFieldset) return;
    if (packFieldset.classList.contains('kvo-pm-fieldset')) return;
    packFieldset.classList.add('kvo-pm-fieldset');

    renderCards(dialog, packFieldset, variants);

    // Cuando Shopify re-renderiza el picker (ej. al cambiar color),
    // nuestra clase kvo-pm-fieldset desaparece → ocultamos el fieldset
    // para evitar el flash de botones planos, y re-aplicamos las cards.
    var reRenderWatcher = new MutationObserver(function () {
      if (!dialog.querySelector('.kvo-pm-fieldset')) {
        reRenderWatcher.disconnect();
        dialog.classList.add('kvo-pm-transitioning');
        setTimeout(function () {
          enhanceDialog(dialog, variants);
          dialog.classList.remove('kvo-pm-transitioning');
        }, 250);
      }
    });
    reRenderWatcher.observe(dialog, { childList: true, subtree: true });
  }

  function tryEnhance(dialog) {
    if (!dialog) return;

    var picker = dialog.querySelector('variant-picker');
    var handle = picker ? picker.dataset.productHandle : null;
    if (!handle) return;

    if (!dialog.querySelector('fieldset.variant-option')) {
      var watcher = new MutationObserver(function () {
        if (dialog.querySelector('fieldset.variant-option')) {
          watcher.disconnect();
          tryEnhance(dialog);
        }
      });
      watcher.observe(dialog, { childList: true, subtree: true });
      return;
    }

    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (d) { enhanceDialog(dialog, d.product.variants); })
      .catch(function () {});
  }

  function watchDialog(d) {
    var attr = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName !== 'open') return;
        if (d.hasAttribute('open')) {
          d.querySelectorAll('.kvo-pm-fieldset').forEach(function (f) {
            f.classList.remove('kvo-pm-fieldset');
          });
          d.querySelectorAll('.kvo-pm-label').forEach(function (l) {
            l.classList.remove('kvo-pm-label');
          });
          setTimeout(function () { tryEnhance(d); }, 200);
        }
      });
    });
    attr.observe(d, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    document.querySelectorAll('dialog').forEach(function (d) {
      watchDialog(d);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1500);

})();

// =====================================================
// KVO CARRITO B — COMPACT + TITLE FIX v3.0
//
// Por qué v3 funciona y v2 no:
//   Horizon calcula padding con min(var(--gap-2xl), var(--gap)).
//   Intentar sobreescribir el padding resultante con !important
//   compite con el propio tema. La solución correcta es anular
//   las variables CSS en el scope del modal (.quick-add-modal)
//   para que todos los cálculos internos del tema usen valores
//   compactos automáticamente.
//
//   Además se inyecta un <style> en <head> TRAS la carga del DOM,
//   lo que garantiza que aparece después de los <link> del tema en
//   el cascade (mismo selector + orden posterior = gana).
//
//   El título no visible en DreamSilk se debe a que el modal abre
//   con scroll ya bajado al variant-picker. scrollTop = 0 lo corrige.
// =====================================================
(function () {
  'use strict';

  var STYLE_ID = 'kvo-compact-b-v3';

  // CSS con override de variables CSS de Horizon + propiedades directas
  var CSS =
    /* Override design tokens al scope del modal */
    '.quick-add-modal{' +
      '--gap:6px;--gap-xs:2px;--gap-sm:4px;--gap-md:6px;' +
      '--gap-lg:8px;--gap-xl:8px;--gap-2xl:8px;--gap-3xl:10px;' +
      '--padding:8px;--padding-sm:4px;--padding-md:8px;--padding-lg:10px;' +
      '--padding-xl:10px;--padding-2xl:10px;--padding-3xl:8px;--padding-4xl:10px;' +
    '}' +
    /* Variant picker */
    '.quick-add-modal__content .product-details .variant-picker,' +
    '.quick-add-modal__content variant-picker{' +
      'padding-top:4px!important;padding-bottom:0!important;' +
      'gap:6px!important;row-gap:6px!important;' +
    '}' +
    /* Group block */
    '.quick-add-modal__content .product-details>.group-block{' +
      'padding-top:6px!important;padding-bottom:0!important;' +
    '}' +
    /* Group block content */
    '.quick-add-modal__content .group-block-content{' +
      'gap:4px!important;row-gap:4px!important;' +
    '}' +
    /* Fieldsets de variantes */
    '.quick-add-modal__content fieldset.variant-option{' +
      'margin-top:0!important;margin-bottom:0!important;' +
      'padding-top:2px!important;padding-bottom:2px!important;' +
    '}' +
    /* Nombre del producto */
    '.quick-add-modal__content .product-title,' +
    '.quick-add-modal__content [class*="product__title"],' +
    '.quick-add-modal__content .product-details h2,' +
    '.quick-add-modal__content .product-details .h2,' +
    '.quick-add-modal__content .product-details h3,' +
    '.quick-add-modal__content .product-details .h3{' +
      'display:block!important;visibility:visible!important;opacity:1!important;' +
      'font-size:1rem!important;font-weight:700!important;' +
      'margin:0 0 4px!important;padding:0 0 4px!important;line-height:1.2!important;' +
    '}' +
    /* Buy buttons */
    '.quick-add-modal__content .buy-buttons-block{' +
      'padding-top:6px!important;padding-bottom:8px!important;margin-top:2px!important;' +
    '}' +
    /* Ocultar precio individual bajo el título — ya aparece en las pack cards */
    '.quick-add-modal__content .price-wrapper,' +
    '.quick-add-modal__content .price,' +
    '.quick-add-modal__content .price__regular,' +
    '.quick-add-modal__content .price__sale,' +
    '.quick-add-modal__content [class*="product-form__price"],' +
    '.quick-add-modal__content .product-price{' +
      'display:none!important;' +
    '}';

  function injectCSS() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  // Scroll al top para que el título del producto sea visible
  function scrollToTop(dialog) {
    var targets = [
      'product-component',
      '#quick-add-modal-content',
      '.quick-add-modal__content',
      '.product-details'
    ];
    targets.forEach(function (sel) {
      var el = dialog.querySelector(sel);
      if (el) el.scrollTop = 0;
    });
  }

  // Galería del modal: el clip lo gestiona CSS estático (614px hardcoded).
  // El CSS sobrevive re-renders de Horizon al cambiar color.
  // Esta función queda como no-op pero se mantiene en caso de necesitar
  // ajustes futuros (ej. si Horizon cambia el alto del panel).
  function clampGallery(dialog) {
    // CSS en koivos-custom.css lo resuelve:
    // .quick-add-modal media-gallery { height: 614px; overflow: hidden }
    // .quick-add-modal .media-gallery__grid { grid-auto-rows: 614px }
  }

  function onOpen(dialog) {
    [50, 200, 500].forEach(function (t) {
      setTimeout(function () {
        scrollToTop(dialog);
        clampGallery(dialog);
      }, t);
    });
  }

  function init() {
    injectCSS();

    var qad = document.getElementById('quick-add-dialog');
    if (!qad) return;
    var dialog = qad.querySelector('dialog');
    if (!dialog) return;

    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'open' && dialog.open) { onOpen(dialog); }
      });
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 800);

}());

// =====================================================
// KVO STOCK ALERT — Reposiciona el aviso de stock
// Saca ".kvo-card__stock" de dentro de la pack card
// (donde rompe la simetría visual entre las 3 cards)
// y lo muestra como alerta naranja debajo del pack grid
// =====================================================
(function () {
  'use strict';

  function hasColorOption(dialog) {
    var fieldsets = dialog.querySelectorAll('fieldset.variant-option');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && legend.textContent.toLowerCase().includes('color')) return true;
    }
    return false;
  }

  function moveStockAlert(dialog) {
    // Limpiar alerta previa si existe
    var prev = dialog.querySelector('.kvo-stock-alert');
    if (prev) prev.remove();

    // Si el producto tiene colores, kvo-picker ya muestra su propio
    // aviso de stock al seleccionar color → no duplicar con el nuestro
    if (hasColorOption(dialog)) return;

    // Buscar texto de stock dentro de las pack cards
    var stockEl = dialog.querySelector('.kvo-card__stock');
    if (!stockEl) return;
    var text = stockEl.textContent.trim();
    if (!text) return;

    // Insertar después del pack grid
    var packGrid = dialog.querySelector('.kvo-pack-grid');
    if (!packGrid) return;

    var alertEl = document.createElement('div');
    alertEl.className = 'kvo-stock-alert';
    alertEl.innerHTML = '<span>⚠️</span><span>' + text + '</span>';
    packGrid.parentNode.insertBefore(alertEl, packGrid.nextSibling);
  }

  function init() {
    var qad = document.getElementById('quick-add-dialog');
    if (!qad) return;
    var dialog = qad.querySelector('dialog');
    if (!dialog) return;

    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'open' && dialog.open) {
          [300, 700, 1300].forEach(function (t) {
            setTimeout(function () { moveStockAlert(dialog); }, t);
          });
        }
      });
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 800);
}());

// =====================================================
// KVO PAYMENT ICONS v3.0 — Carrito A & B
//
// Cada icono dispara su método de pago real:
//   Visa / MC / Amex → /checkout (campo tarjeta)
//   Shop Pay         → click directo en shop-pay-button
//   PayPal           → busca botón PayPal de Shopify → dispara
//   Apple Pay        → solo Safari/iPhone con Apple Pay activado
//   Google Pay       → solo Chrome con Google Pay activado
//   Klarna / Bizum   → "Más opciones de pago" (están en esa pantalla)
//
// Fallback universal: si el botón específico no existe en la página
// (porque no está habilitado en Shopify Payments), abre
// "Más opciones de pago" para que el cliente elija manualmente.
// =====================================================
(function () {
  'use strict';

  // Métodos activos en Koivos (España):
  // Shop Pay, Visa, MC, Amex, Maestro, PayPal, Apple Pay, Google Pay, Klarna
  // El botón grande de Shop Pay está oculto con CSS — el icono aquí lo dispara via JS.
  var ICONS =
    '<svg class="kvo-pay-icon" data-kvo-pay="shoppay"   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" aria-label="Comprar con Shop Pay"><rect width="60" height="30" rx="3" fill="#5C2D91"/><text x="30" y="20" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="700" font-size="11" letter-spacing="0.3">Shop Pay</text></svg>' +
    '<svg class="kvo-pay-icon" data-kvo-pay="visa"      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" aria-label="Pagar con Visa"><rect width="50" height="30" rx="3" fill="#1A1F71"/><text x="25" y="21" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="700" font-style="italic" font-size="15" letter-spacing="1">VISA</text></svg>' +
    '<svg class="kvo-pay-icon" data-kvo-pay="mc"        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" aria-label="Pagar con Mastercard"><rect width="50" height="30" rx="3" fill="white" stroke="#ddd" stroke-width="1"/><circle cx="19" cy="15" r="9" fill="#EB001B"/><circle cx="31" cy="15" r="9" fill="#F79E1B"/><ellipse cx="25" cy="15" rx="3.5" ry="9" fill="#FF5F00"/></svg>' +
    '<svg class="kvo-pay-icon" data-kvo-pay="amex"      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" aria-label="Pagar con Amex"><rect width="50" height="30" rx="3" fill="#2E77BC"/><text x="25" y="20" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="700" font-size="11" letter-spacing="0.5">AMEX</text></svg>' +
    '<svg class="kvo-pay-icon" data-kvo-pay="maestro"   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" aria-label="Pagar con Maestro"><rect width="50" height="30" rx="3" fill="white" stroke="#ddd" stroke-width="1"/><circle cx="20" cy="15" r="10" fill="#0052A5" opacity="0.9"/><circle cx="30" cy="15" r="10" fill="#EE0000" opacity="0.85"/><text x="25" y="19" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="700" font-size="7">maestro</text></svg>' +
    '<svg class="kvo-pay-icon" data-kvo-pay="paypal"    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" aria-label="Pagar con PayPal"><rect width="50" height="30" rx="3" fill="#003087"/><text x="25" y="20" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="700" font-size="11">PayPal</text></svg>' +
    '<svg class="kvo-pay-icon" data-kvo-pay="applepay"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" aria-label="Pagar con Apple Pay"><rect width="50" height="30" rx="3" fill="black"/><text x="25" y="20" text-anchor="middle" fill="white" font-family="Arial,sans-serif" font-weight="500" font-size="10">Apple Pay</text></svg>' +
    '<svg class="kvo-pay-icon" data-kvo-pay="googlepay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" aria-label="Pagar con Google Pay"><rect width="50" height="30" rx="3" fill="white" stroke="#ddd" stroke-width="1"/><text x="24" y="20" text-anchor="middle" font-family="Arial,sans-serif" font-weight="700" font-size="10"><tspan fill="#4285F4">G</tspan><tspan fill="#555"> Pay</tspan></text></svg>' +
    '<svg class="kvo-pay-icon" data-kvo-pay="klarna"    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" aria-label="Pagar con Klarna"><rect width="50" height="30" rx="3" fill="#FFB3C7"/><text x="25" y="20" text-anchor="middle" fill="#17120F" font-family="Arial,sans-serif" font-weight="700" font-size="11">Klarna</text></svg>'+
        '<svg class="kvo-pay-icon" data-kvo-pay="bizum"     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" aria-label="Pagar con Bizum"><rect width="50" height="30" rx="3" fill="white" stroke="#ddd" stroke-width="1"/><text x="25" y="19" text-anchor="middle" fill="#00A9E0" font-family="Arial,sans-serif" font-weight="700" font-size="10">bizum</text></svg>';

  // ── Buscar un botón branded por palabras clave en su HTML ──
  function findBranded(payBtn, keywords) {
    var candidates = payBtn.querySelectorAll(
      '.shopify-payment-button__button--branded, [data-branded-button], [data-payment-button]'
    );
    for (var i = 0; i < candidates.length; i++) {
      var html = candidates[i].innerHTML.toLowerCase();
      var label = (candidates[i].getAttribute('aria-label') || '').toLowerCase();
      for (var k = 0; k < keywords.length; k++) {
        if (html.indexOf(keywords[k]) !== -1 || label.indexOf(keywords[k]) !== -1) {
          return candidates[i];
        }
      }
    }
    return null;
  }

  // ── Fallback: disparar "Más opciones de pago" ──
  function triggerMore(payBtn) {
    var btn =
      payBtn.querySelector('.shopify-payment-button__more-options button') ||
      payBtn.querySelector('.shopify-payment-button__more-options a')      ||
      // Horizonte renderiza el "more options" como último button dentro del bloque
      Array.prototype.slice.call(
        payBtn.querySelectorAll('button[type="button"], a')
      ).pop();
    if (btn) btn.click();
  }

  // ── Router de métodos de pago ──
  function handlePayClick(payBtn, type) {
    switch (type) {

      // Tarjeta estándar → ir al checkout con formulario de tarjeta
      case 'visa':
      case 'mc':
      case 'amex':
      case 'maestro':
        window.location.href = '/checkout';
        return;

      // Shop Pay → click directo en el custom element
      case 'shoppay': {
        var spb = payBtn.querySelector('shop-pay-button');
        if (spb) { spb.click(); return; }
        triggerMore(payBtn);
        return;
      }

      // PayPal → buscar botón PayPal renderizado por Shopify Payments
      case 'paypal': {
        var pp = findBranded(payBtn, ['paypal']);
        if (pp) { pp.click(); return; }
        triggerMore(payBtn);
        return;
      }

      // Apple Pay → solo Safari + Apple Pay configurado en Shopify Payments
      case 'applepay': {
        if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
          var ap = findBranded(payBtn, ['apple-pay', 'apple_pay', 'applepay', 'apple pay']);
          if (ap) { ap.click(); return; }
        }
        // Dispositivo sin Apple Pay → "Más opciones"
        triggerMore(payBtn);
        return;
      }

      // Google Pay → Chrome con Google Pay activado
      case 'googlepay': {
        var gp = findBranded(payBtn, ['google-pay', 'google_pay', 'googlepay', 'google pay']);
        if (gp) { gp.click(); return; }
        triggerMore(payBtn);
        return;
      }

      // Klarna y Bizum → disponibles en "Más opciones de pago"
      case 'klarna':
      case 'bizum':
      default:
        triggerMore(payBtn);
        return;
    }
  }

  // ── Inyectar fila de iconos debajo de .shopify-payment-button ──
  // ── Ocultar el botón Shop Pay grande vía JS ──
  function hideBranded(payBtn) {
    function killBranded() {
      payBtn.querySelectorAll(
        '.shopify-payment-button__button--branded, shop-pay-button'
      ).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
        el.style.setProperty('min-height', '0', 'important');
      });
    }
    // Matar ahora y cada vez que el contenedor cambie (Shopify puede reinsertar)
    killBranded();
    new MutationObserver(killBranded).observe(payBtn, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['style', 'class']
    });
    // Intervalo de respaldo durante 8 segundos por si renderiza tarde
    var n = 0;
    var iv = setInterval(function () { killBranded(); if (++n >= 16) clearInterval(iv); }, 500);
  }

  function inject(payBtn) {
    if (!payBtn) return;
    var parent = payBtn.parentNode;
    if (!parent || parent.querySelector('.kvo-pay-wrap')) return;

    var el = document.createElement('div');
    el.className = 'kvo-pay-wrap';
    el.innerHTML =
      '<p class="kvo-pay-label">🔒 Pago seguro — elige tu método:</p>' +
      '<div class="kvo-pay-icons">' + ICONS + '</div>';
    parent.insertBefore(el, payBtn.nextSibling);

    // Delegar click a cada icono según su data-kvo-pay
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var icon = e.target.closest('[data-kvo-pay]');
      if (!icon) return;
      handlePayClick(payBtn, icon.getAttribute('data-kvo-pay'));
    });

    // Ocultar el botón grande (lo reemplaza el icono Shop Pay de la fila)
    hideBranded(payBtn);
  }

  function scanAll() {
    document.querySelectorAll('.shopify-payment-button').forEach(inject);
  }

  // ── Observer selectivo: quick-add modal (Carrito B) ──
  function watchQuickAdd() {
    var qad = document.getElementById('quick-add-dialog');
    if (!qad) return;
    var dialog = qad.querySelector('dialog');
    if (!dialog) return;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'open' && dialog.open) {
          [500, 1000, 1800].forEach(function (t) { setTimeout(scanAll, t); });
        }
      });
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  // ── Observer selectivo: cart drawer (Carrito A) ──
  function watchCartDrawer() {
    var cartEl = document.querySelector('cart-drawer') ||
                 document.querySelector('[id*="CartDrawer"]') ||
                 document.querySelector('.cart-drawer');
    if (!cartEl) return;
    new MutationObserver(function () {
      setTimeout(scanAll, 400);
    }).observe(cartEl, {
      attributes: true, childList: true,
      attributeFilter: ['class', 'open', 'aria-hidden', 'aria-expanded']
    });
  }

  function init() {
    scanAll();
    watchQuickAdd();
    watchCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  [800, 1600, 3000].forEach(function (t) { setTimeout(scanAll, t); });
}());

// =====================================================
// KVO MODAL IMAGE SYNC v2.0
// El kvo-picker maneja su propio selector de color pero
// NO dispara el evento que Horizon necesita para cambiar
// la imagen en la galería del modal.
//
// Solución: cuando se hace click en un kvo-swatch,
// activamos el radio input equivalente en el native
// variant-picker (oculto, 4px) para que Horizon dispare
// variant-changed → media-gallery actualiza la imagen.
// =====================================================
(function () {
  'use strict';

  function syncNativePicker(dialog, colorValue) {
    // Buscar el fieldset de Color en el native variant-picker
    var fieldsets = dialog.querySelectorAll('fieldset.variant-option');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (!legend) continue;
      if (!legend.textContent.toLowerCase().includes('color')) continue;

      // Encontrar el radio con el valor del color seleccionado
      var inputs = fieldsets[i].querySelectorAll('input[type="radio"]');
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value === colorValue) {
          // Activar: checked + eventos + click
          // Esto hace que variant-picker dispare variant-changed
          // y media-gallery actualiza la imagen automáticamente
          inputs[j].checked = true;
          inputs[j].dispatchEvent(new Event('input',  { bubbles: true }));
          inputs[j].dispatchEvent(new Event('change', { bubbles: true }));
          inputs[j].click();
          return;
        }
      }
    }
  }

  function init() {
    var qad = document.getElementById('quick-add-dialog');
    if (!qad) return;
    var dialog = qad.querySelector('dialog');
    if (!dialog) return;

    dialog.addEventListener('click', function (e) {
      var swatch = e.target.closest('.kvo-swatch');
      if (!swatch) return;
      // El title del kvo-swatch contiene el nombre del color
      var colorValue = swatch.title || swatch.getAttribute('data-color') || '';
      if (!colorValue) return;

      // Pequeño delay para que kvo-picker actualice primero su estado
      setTimeout(function () {
        syncNativePicker(dialog, colorValue);
      }, 150);

      // Horizon re-renderiza la galería al cambiar de color y borra
      // los estilos inline que clampGallery inyectó. Re-aplicarlos.
      [400, 800, 1400].forEach(function (t) {
        setTimeout(function () { clampGallery(dialog); }, t);
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 800);
}());

// =====================================================
// KVO COLLECTION PAGE — Professional Redesign v2.0
//
// Estrategia corregida: en Horizon la sección del título
// y la de productos son dos shopify-sections distintos.
// Aplicamos el fondo al .section-background del primero
// (ya tiene position:absolute;inset:0 → full-width auto).
// =====================================================
(function () {
  'use strict';

  // Horizon NO añade 'template-collection' al body — usa data-template en <main>
  // o podemos detectar por URL. Usamos ambos para máxima fiabilidad.
  var isCollection = !!document.querySelector('main[data-template="collection"]') ||
                     window.location.pathname.indexOf('/collections/') !== -1;
  if (!isCollection) return;

  var CSS =
    // Fondo full-width: .section-background es position:absolute;inset:0 en Horizon
    '.kvo-col-bg{background:linear-gradient(135deg,#0b1629 0%,#0f1f3d 60%,#0c1a35 100%)!important;}' +
    // Línea dorada superior sobre el shopify-section
    '.kvo-col-section{position:relative!important;}' +
    '.kvo-col-section::before{content:"";position:absolute;top:0;left:0;right:0;height:2px;z-index:2;' +
      'background:linear-gradient(to right,transparent,#C9A95A 30%,#C9A95A 70%,transparent);opacity:0.75;pointer-events:none;}' +
    // Título
    '.kvo-col-title{color:#f8f4ee!important;font-size:clamp(2rem,5vw,3rem)!important;' +
      'font-weight:700!important;letter-spacing:-0.03em!important;line-height:1.05!important;}' +
    '.kvo-col-title::after{content:"";display:block;width:44px;height:2px;background:#C9A95A;margin-top:18px;border-radius:1px;}' +
    // Descripción
    '.kvo-col-desc,.kvo-col-desc p,.kvo-col-desc *{color:#94a3b8!important;font-size:0.95rem!important;line-height:1.7!important;}' +
    // Tarjetas
    '.kvo-col-card{transition:transform 0.3s cubic-bezier(.25,.46,.45,.94),box-shadow 0.3s cubic-bezier(.25,.46,.45,.94)!important;}' +
    '.kvo-col-card:hover{transform:translateY(-6px)!important;box-shadow:0 24px 48px rgba(0,0,0,0.14),0 0 0 1.5px rgba(201,169,90,0.3)!important;}' +
    '.kvo-col-card>.card,.kvo-col-card .card{border:1px solid rgba(0,0,0,0.07)!important;border-radius:14px!important;overflow:hidden!important;transition:border-color 0.3s!important;}' +
    '.kvo-col-card:hover>.card,.kvo-col-card:hover .card{border-color:rgba(201,169,90,0.3)!important;}' +
    '.kvo-col-card .card__media{overflow:hidden!important;}' +
    '.kvo-col-card .card__media img{transition:transform 0.6s cubic-bezier(.25,.46,.45,.94)!important;transform-origin:center center;}' +
    '.kvo-col-card:hover .card__media img{transform:scale(1.07)!important;}' +
    '.kvo-col-card .card__information,.kvo-col-card .card__content{padding:14px 16px 18px!important;}' +
    '.kvo-col-card .card__heading a,.kvo-col-card .card__heading{font-size:0.92rem!important;font-weight:600!important;color:#0f172a!important;letter-spacing:-0.01em!important;transition:color 0.2s!important;line-height:1.35!important;}' +
    '.kvo-col-card:hover .card__heading a{color:#1E3A8A!important;}' +
    '.kvo-col-card .price-item--regular{font-size:1.04rem!important;font-weight:700!important;color:#0f172a!important;}' +
    '.kvo-col-card .price-item--sale{font-size:1.04rem!important;font-weight:700!important;color:#C9A95A!important;}' +
    // Grid — 3 columnas premium (desktop). Horizon pone 5 por defecto.
    '.kvo-on-collection .product-grid{display:grid!important;width:100%!important;height:auto!important;max-height:none!important;min-height:auto!important;overflow:visible!important;grid-template-columns:repeat(3,1fr)!important;gap:32px 24px!important;}' +
    // En móvil (<600px) 1 columna; tablet 2 columnas
    '@media(max-width:599px){.kvo-on-collection .product-grid{display:grid!important;width:100%!important;height:auto!important;max-height:none!important;min-height:auto!important;overflow:visible!important;grid-template-columns:1fr!important;gap:20px!important;}}' +
    '@media(min-width:600px) and (max-width:899px){.kvo-on-collection .product-grid{display:grid!important;width:100%!important;height:auto!important;max-height:none!important;min-height:auto!important;overflow:visible!important;grid-template-columns:repeat(2,1fr)!important;gap:24px 20px!important;}}' +

    // ── Sección Vídeos del producto ──
    '.koivos-vs{background:#f8f7f4!important;position:relative!important;}' +
    // Línea dorada en la parte superior
    '.koivos-vs::before{content:"";position:absolute;top:0;left:50%;transform:translateX(-50%);' +
      'width:min(640px,80vw);height:1px;' +
      'background:linear-gradient(to right,transparent,#C9A95A 30%,#C9A95A 70%,transparent);' +
      'opacity:0.5;}' +
    // Título
    '.koivos-vs__title{color:#0f172a!important;font-weight:700!important;letter-spacing:-0.02em!important;}' +
    '.koivos-vs__title::after{content:"";display:block;width:44px;height:2px;background:#C9A95A;margin:14px auto 0;border-radius:1px;}' +
    // Subtítulo
    '.koivos-vs__subtitle{color:#64748b!important;font-size:1rem!important;}' +
    // Embeds — bordes redondeados y sombra sutil
    '.koivos-vs__embed-wrap{border-radius:12px!important;box-shadow:0 8px 32px rgba(0,0,0,0.10)!important;' +
      'transition:transform 0.3s ease,box-shadow 0.3s ease!important;}' +
    '.koivos-vs__embed-wrap:hover{transform:translateY(-4px)!important;box-shadow:0 16px 48px rgba(0,0,0,0.15)!important;}' +
    '.koivos-vs__caption{color:#64748b!important;font-size:0.82rem!important;letter-spacing:0.02em!important;}' +

    // ── Separación visual hero → grid ──
    // Respiro inferior del hero
    '.kvo-col-section{padding-bottom:48px!important;}' +
    // Sección del grid: línea dorada arriba + espacio generoso
    '.kvo-col-grid-section{position:relative!important;padding-top:56px!important;padding-bottom:64px!important;}' +
    '.kvo-col-grid-section::before{content:"";position:absolute;top:0;left:50%;transform:translateX(-50%);' +
      'width:min(640px,80vw);height:1px;' +
      'background:linear-gradient(to right,transparent,#C9A95A 30%,#C9A95A 70%,transparent);' +
      'opacity:0.45;}' +
    // Judge.me stars — integración visual
    '.kvo-stars-badge{margin:5px 0 6px!important;display:block!important;min-height:18px;}' +
    '.kvo-stars-badge .jdgm-prev-badge{display:flex!important;align-items:center!important;gap:4px!important;flex-wrap:wrap!important;}' +
    '.kvo-stars-badge .jdgm-star{color:#C9A95A!important;}' +
    '.kvo-stars-badge .jdgm-prev-badge__rating{font-size:0.73rem!important;color:#64748b!important;font-weight:600!important;}' +
    '.kvo-stars-badge .jdgm-prev-badge__rev-count{font-size:0.70rem!important;color:#94a3b8!important;}' +

    // ── FIX CRÍTICO: Anular overflow:hidden del body en Shopify ──
    '@media(min-width:990px){html.kvo-on-collection body{overflow:visible!important;height:auto!important;}}' +
    '@media(max-width:989px){html.kvo-on-collection body{overflow:visible!important;height:auto!important;}}' +
    '';

  // ── JAVASCRIPT FIX: Forzar directamente overflow:visible en body ──
  var isCollection = !!document.querySelector('main[data-template="collection"]') || window.location.pathname.indexOf('/collections/') !== -1;
  if (isCollection) {
    function fixBodyOverflow() {
      document.body.style.setProperty('overflow', 'visible', 'important');
      document.body.style.setProperty('height', 'auto', 'important');
      document.body.style.setProperty('width', 'auto', 'important');
      document.body.style.setProperty('position', 'static', 'important');
      document.documentElement.style.setProperty('overflow', 'visible', 'important');
      document.documentElement.style.setProperty('height', 'auto', 'important');
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixBodyOverflow);
    } else {
      fixBodyOverflow();
    }
    [100, 300, 600, 1000, 2000].forEach(function(t) { setTimeout(fixBodyOverflow, t); });
  }

  // Inyectar CSS (reemplazar versión anterior si existe)
  var existingStyle = document.getElementById('kvo-collection-v1');
  if (existingStyle) existingStyle.remove();
  var styleEl = document.createElement('style');
  styleEl.id = 'kvo-collection-v1';
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  function styleCards() {
    document.querySelectorAll('.card-wrapper:not(.kvo-col-card)').forEach(function(c) {
      c.classList.add('kvo-col-card');
    });
  }

  function init() {
    document.body.classList.add('kvo-on-collection');

    if (document.querySelector('.kvo-col-section')) { styleCards(); return; }

    var h1 = document.querySelector('main h1, #MainContent h1, [id*="MainContent"] h1');
    if (!h1) return;

    // Subir al shopify-section que contiene el h1
    // En Horizon: .section-wrapper o [id^="shopify-section-template"]
    var heroSection = h1.closest('.section-wrapper') ||
                      h1.closest('[id^="shopify-section-template"]') ||
                      h1.closest('.shopify-section');

    if (heroSection) {
      heroSection.classList.add('kvo-col-section');
      // .section-background es position:absolute;inset:0 → ya es full-width
      var bg = heroSection.querySelector('.section-background');
      if (bg) {
        bg.classList.add('kvo-col-bg');
      } else {
        // Fallback: aplicar fondo al propio section
        heroSection.style.setProperty(
          'background',
          'linear-gradient(135deg,#0b1629 0%,#0f1f3d 60%,#0c1a35 100%)',
          'important'
        );
      }
    }

    // Título
    h1.classList.add('kvo-col-title');

    // Descripción: buscar en el mismo contenedor de layout que el h1
    var layoutEl = h1.closest('.section-content-wrapper') ||
                   h1.closest('[class*="layout-panel"]') ||
                   h1.closest('[class*="spacing-style"]') ||
                   h1.parentElement;

    if (layoutEl) {
      var desc = layoutEl.querySelector('.rte,[class*="description"],[class*="desc"]');
      if (!desc) {
        var kids = layoutEl.children;
        for (var i = 0; i < kids.length; i++) {
          if (kids[i] !== h1 && kids[i].tagName !== 'STYLE' && kids[i].tagName !== 'SCRIPT' && kids[i].textContent.trim()) {
            desc = kids[i]; break;
          }
        }
      }
      if (desc && desc !== h1) desc.classList.add('kvo-col-desc');
    }

    // Marcar sección del grid para separación visual
    var gridEl = document.querySelector('.product-grid');
    if (gridEl) {
      var gridSection = gridEl.closest('.shopify-section') || gridEl.closest('[id^="shopify-section"]');
      if (gridSection && !gridSection.classList.contains('kvo-col-section')) {
        gridSection.classList.add('kvo-col-grid-section');
      }
    }

    styleCards();
    injectJudgeMeStars();
  }

  // Inyecta el placeholder de Judge.me en cada tarjeta y dispara el render
  function injectJudgeMeStars() {
    document.querySelectorAll('product-card:not(.kvo-stars-done)').forEach(function(card) {
      var productId = card.dataset && card.dataset.productId;
      if (!productId) return;

      var price = card.querySelector('product-price');
      if (!price || !price.parentNode) return;

      var badge = document.createElement('div');
      badge.className = 'jdgm-widget jdgm-preview-badge kvo-stars-badge';
      badge.setAttribute('data-id', productId);
      price.parentNode.insertBefore(badge, price);
      card.classList.add('kvo-stars-done');
    });

    // Disparar render de Judge.me
    if (window.jdgm && window.jdgm.PREVIEW_BADGE && typeof window.jdgm.PREVIEW_BADGE.loadFromDom === 'function') {
      window.jdgm.PREVIEW_BADGE.loadFromDom();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  [300, 800, 1800].forEach(function(t) { setTimeout(init, t); });
  [500, 1100].forEach(function(t) { setTimeout(styleCards, t); });
  [600, 1200, 2500].forEach(function(t) { setTimeout(injectJudgeMeStars, t); });

  document.addEventListener('DOMContentLoaded', function() {
    var grid = document.querySelector('.product-grid,[class*="product-grid"]');
    if (!grid) return;
    new MutationObserver(function() { styleCards(); }).observe(grid, { childList: true, subtree: true });
  });

  /* =====================================================
     CARRUSEL GALERÍA PRODUCTO — Dots indicadores
     CSS en koivos-mobile.css Sección 18 punto 6.
     .kvo-gal-mobile ya es horizontal con scroll-snap.
     Esta función inyecta puntos de navegación debajo.
  ===================================================== */
  function initProductCarousel() {
    if (window.innerWidth > 749) return;
    var carousel = document.querySelector('.kvo-gal-mobile');
    if (!carousel) return;
    if (document.getElementById('kv-carousel-dots')) return;
    var items = carousel.querySelectorAll('.kvo-gal-mobile__item');
    if (items.length <= 1) return;

    var dotsContainer = document.createElement('div');
    dotsContainer.id = 'kv-carousel-dots';
    dotsContainer.className = 'kv-carousel-dots';

    var dots = Array.prototype.map.call(items, function(item, i) {
      var dot = document.createElement('button');
      dot.className = 'kv-carousel-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Imagen ' + (i + 1));
      dot.addEventListener('click', function() {
        carousel.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
      return dot;
    });

    carousel.parentNode.insertBefore(dotsContainer, carousel.nextSibling);

    var scrollTimeout;
    carousel.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var idx = Math.round(carousel.scrollLeft / carousel.offsetWidth);
        dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
      }, 50);
    }, { passive: true });
  }

  [400, 900, 1800].forEach(function(t) { setTimeout(initProductCarousel, t); });

}());

// =====================================================
// KVO TALLA SELECTOR v1.0
// El kvo-code del tema genera Pack cards (1u/2u/3u) para
// TODOS los productos con una segunda opción, aunque
// se llame "Talla" en lugar de "Pack".
// Este script detecta productos con opción "Talla" (sin "Pack")
// y reemplaza el pack-grid con un selector de talla real.
// =====================================================
(function () {
  'use strict';

  function getTallaValues(product) {
    var tallaIdx = product.options.indexOf('Talla');
    if (tallaIdx === -1) return null;
    var optKey = 'option' + (tallaIdx + 1);
    var values = [];
    product.variants.forEach(function (v) {
      var val = v[optKey];
      if (val && values.indexOf(val) === -1) values.push(val);
    });
    return values;
  }

  function getSelectedColor() {
    var swatch = document.querySelector('.kvo-swatch.active');
    return swatch ? swatch.title : null;
  }

  function getVariant(product, color, talla) {
    var colorIdx = product.options.indexOf('Color');
    var tallaIdx = product.options.indexOf('Talla');
    if (colorIdx === -1 || tallaIdx === -1) return null;
    var cKey = 'option' + (colorIdx + 1);
    var tKey = 'option' + (tallaIdx + 1);
    return product.variants.find(function (v) {
      return v[cKey] === color && v[tKey] === talla;
    }) || null;
  }

  function updateVariant(variantId) {
    // Actualizar input hidden de Shopify
    document.querySelectorAll('input[name="id"]').forEach(function (input) {
      if (parseInt(input.value) === variantId) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    // Actualizar select si existe
    var sel = document.querySelector('select[name="id"]');
    if (sel) { sel.value = variantId; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    // Actualizar precio visible si el tema expone la función
    if (window.theme && window.theme.updateProduct) {
      window.theme.updateProduct({ id: variantId });
    }
  }

  function injectTallaSelector(product, tallaValues) {
    var picker = document.querySelector('.kvo-picker');
    if (!picker) return;
    if (picker.querySelector('.kvo-talla-injected')) return;

    // Encontrar la sección del Pack
    var packSection = null;
    picker.querySelectorAll('.kvo-section').forEach(function (s) {
      if (s.querySelector('.kvo-pack-grid')) packSection = s;
    });
    if (!packSection) return;

    // Ocultar pack y multi-color
    packSection.style.setProperty('display', 'none', 'important');
    var unitColors = picker.querySelector('.kvo-unit-colors');
    if (unitColors) unitColors.style.setProperty('display', 'none', 'important');

    var selectedTalla = tallaValues[0];

    // Crear selector de talla
    var section = document.createElement('div');
    section.className = 'kvo-section kvo-talla-injected';
    section.innerHTML =
      '<div class="kvo-label">Talla: <span class="kvo-label__val kvo-talla-current">' + selectedTalla + '</span></div>' +
      '<div class="kvo-talla-btns">' +
      tallaValues.map(function (v) {
        return '<button type="button" class="kvo-talla-btn' + (v === selectedTalla ? ' active' : '') + '" data-talla="' + v + '">' + v + '</button>';
      }).join('') +
      '</div>';

    packSection.parentNode.insertBefore(section, packSection);

    // Selección de talla
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('.kvo-talla-btn');
      if (!btn) return;
      section.querySelectorAll('.kvo-talla-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      selectedTalla = btn.dataset.talla;
      section.querySelector('.kvo-talla-current').textContent = selectedTalla;
      var color = getSelectedColor();
      var v = getVariant(product, color, selectedTalla);
      if (v) updateVariant(v.id);
    });

    // Sincronizar cuando cambia el color
    picker.querySelectorAll('.kvo-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        setTimeout(function () {
          var color = getSelectedColor();
          var v = getVariant(product, color, selectedTalla);
          if (v) updateVariant(v.id);
        }, 250);
      });
    });

    // Seleccionar variante inicial
    var color = getSelectedColor();
    var v = getVariant(product, color, selectedTalla);
    if (v) updateVariant(v.id);

    // Resetear cantidad a 1 (kvo-code la pone a 2 por el pack "Más vendido")
    [100, 400, 900].forEach(function (t) {
      setTimeout(function () {
        var qInput = document.querySelector('input[name="quantity"]');
        if (qInput && parseInt(qInput.value) !== 1) {
          qInput.value = 1;
          qInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, t);
    });
  }

  function init() {
    var product = window.kvo_product;
    if (!product || !product.options || !product.variants) return;
    if (product.options.indexOf('Pack') !== -1) return; // producto con Pack — no tocar
    var tallaValues = getTallaValues(product);
    if (!tallaValues || tallaValues.length === 0) return;
    injectTallaSelector(product, tallaValues);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  [500, 1200, 2500].forEach(function (t) { setTimeout(init, t); });

}());

// =====================================================
// KVO NO-COLOR HIDER v1.1
// Oculta toda la UI de color cuando el producto tiene
// solo 1 valor de color (ej: "1 unidad" con opción Color).
// Oculta: label "Color: X" en .kvo-section + .kvo-unit-colors
// Nota: cuando hay 1 solo color, .kvo-swatches no se renderiza,
// por lo que se detecta la sección por su contenido de texto.
// =====================================================
(function () {
  'use strict';

  function getUniqueColorValues(product) {
    if (!product || !product.options || !product.variants) return [];
    var idx = -1;
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].toLowerCase() === 'color') { idx = i; break; }
    }
    if (idx === -1) return [];
    var key = 'option' + (idx + 1);
    var seen = [];
    product.variants.forEach(function (v) {
      var val = v[key];
      if (val && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  function hideColorUI() {
    var product = window.kvo_product;
    if (!product) return;
    var colors = getUniqueColorValues(product);
    if (colors.length !== 1) return; // 0 = sin opción color, 2+ = colores reales → no tocar

    // 1a. Ocultar la .kvo-section que muestra "Color: X" (kvo-picker)
    document.querySelectorAll('.kvo-section').forEach(function (section) {
      var text = section.textContent.trim();
      if (/^color:/i.test(text)) {
        section.style.setProperty('display', 'none', 'important');
      }
    });

    // 1b. Ocultar el picker NATIVO de Shopify (.variant-option dentro de
    //     .variant-picker__form) que muestra "color  1 unidad"
    document.querySelectorAll('.variant-picker__form .variant-option, .variant-option').forEach(function (opt) {
      var label = opt.querySelector('label, legend, dt, [class*="label"]');
      var labelText = label ? label.textContent.trim() : opt.childNodes[0] ? opt.childNodes[0].textContent.trim() : '';
      if (/^color/i.test(labelText)) {
        opt.style.setProperty('display', 'none', 'important');
      }
    });

    // 2. Ocultar .kvo-swatches si existe (productos con 1 swatch visual)
    var swatchContainer = document.querySelector('.kvo-swatches');
    if (swatchContainer) {
      var swatchSection = swatchContainer.closest('.kvo-section') || swatchContainer.parentElement;
      if (swatchSection) swatchSection.style.setProperty('display', 'none', 'important');
    }

    // 3. Ocultar .kvo-unit-colors en picker de packs
    //    ("Elige el color de cada unidad")
    document.querySelectorAll('.kvo-unit-colors').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideColorUI);
  } else {
    hideColorUI();
  }
  [400, 900, 2000].forEach(function (t) { setTimeout(hideColorUI, t); });

}());

// =====================================================
// KVO DEFAULT PACK SELECTOR v1.0
// kvo-code selecciona "2 unidades" (Más vendido) por defecto
// y pone la cantidad a 2. Este bloque fuerza "1 unidad"
// como selección inicial y cantidad = 1.
// Solo afecta a productos con .kvo-pack-grid.
// El usuario puede cambiar el pack normalmente después.
// =====================================================
(function () {
  'use strict';

  var done = false;

  function selectFirstPack() {
    if (done) return;
    var packGrid = document.querySelector('.kvo-pack-grid');
    if (!packGrid) return;

    var cards = packGrid.querySelectorAll('.kvo-pack-card');
    if (cards.length === 0) return;

    var firstCard = cards[0]; // "1 unidad"
    // Si ya está activa, solo asegurar qty=1
    if (!firstCard.classList.contains('active')) {
      firstCard.click();
    }

    // Forzar cantidad = 1 como respaldo
    setTimeout(function () {
      var qInput = document.querySelector('input[name="quantity"]');
      if (qInput && parseInt(qInput.value) !== 1) {
        qInput.value = 1;
        qInput.dispatchEvent(new Event('input', { bubbles: true }));
        qInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 150);

    done = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(selectFirstPack, 600); });
  } else {
    setTimeout(selectFirstPack, 600);
  }
  [800, 1400].forEach(function (t) { setTimeout(selectFirstPack, t); });

}());